import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import * as styles from './BlankBanner.module.scss'
import TextLogo from '../../../assets/new-icons/bamboo_text_logo.svg'

function BlankBanner({ className, ...rest }) {
  return (
    <div
      className={classNames(styles.blankBannerContainer, className)}
      {...rest}
    >
      <img
        className={styles.textLogo}
        src={TextLogo}
        width="256"
        height="45"
        alt="Bamboo investments App"
      />
    </div>
  )
}

BlankBanner.propTypes = {
  className: PropTypes.string,
}

export default React.memo(BlankBanner)
